import type { IconProps } from '../types/IconProps.ts';
export const Grid2x2X: IconProps = {
    name: 'Grid2x2X',
    children: [
        `<path d="M12 21H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v8M3 12h18M12 3v18M16 16l6 5M16 21l6-5" />`,
    ]
};